<template>
  <div class="">
    <Article
    head_title1="Professionelle Umzugshelfer "
    head_title2="für Ihren Umzug"
    head_subtitle="Umzug Bayern organisiert Privatumzüge, Studentenumzüge, Seniorenumzüge, Umzüge für Unternehmen und Büros."
    meta_title="Umzugsservice | Umzug-Bayern.com"
    page_title="Umzugsdienstleistungen im Überblick"
    :keywords="['Umzug']"
    description="Suchen Sie jemanden, der Ihnen bei der Organisation Ihres Umzugs hilft? Dann sind Sie bei uns genau richtig! Umzug nach Bayern zu besonders günstigen Preisen. Füllen Sie das Feedback-Formular aus oder kontaktieren Sie uns telefonisch."
    :share_buttons="true">
    <div class="bg-light py-4">
      <div class="container">
      <div class="row d-flex">
      <div class="col-12 col-md-6 mt-4 d-flex">
      <MDBCard text="center">
        <MDBCardBody v-once  class="flex-column d-flex">
          <MDBCardTitle v-once  tag="h2" class="text-uppercase h3">Privatumzug</MDBCardTitle>
          <MDBCardText v-once>
              <p>Unser Unternehmen bietet umfassende und stressfreie Privatumzugsdienstleistungen in Bayern, München und ganz Deutschland – inklusive detaillierter Planung, professionellem Packservice, Transport, Montagearbeiten und individueller Betreuung zu wettbewerbsfähigen Preisen – für einen reibungslosen und sorglosen Umzugserlebnis.</p>
          </MDBCardText>
          <router-link alt="Privatumzug" title="Privatumzug" :to="{ name: 'privatumzuege' }" class="mt-auto btn  btn-primary btn-lg">Privatumzüge</router-link>
        </MDBCardBody>
      </MDBCard>
      </div>
      <div class="col-12 col-md-6 mt-4 d-flex">
        <MDBCard text="center">
          <MDBCardBody v-once  class="flex-column d-flex">
            <MDBCardTitle v-once  tag="h2" class="text-uppercase h3">Seniorenumzüge</MDBCardTitle>
            <MDBCardText v-once>
              <p>Wir bieten professionelle und zuverlässige Seniorenumzüge an, die durch sorgfältige Planung, schonenden Transport und umfassende Dienstleistungen wie Packen, Möbelmontage und Entrümpelung einen stressfreien Umzug für ältere Menschen ermöglichen. Unsere erfahrenen Umzugshelfer kümmern sich um alle Details, sodass sich Senioren auf ihren neuen Lebensabschnitt freuen können.</p>
            </MDBCardText>
            <router-link alt="Seniorenumzug" title="Seniorenumzzg" :to="{ name: 'seniorenumzuege' }" class="mt-auto btn   btn-primary btn-lg">Seniorenumzüge</router-link>
          </MDBCardBody>
        </MDBCard>
      </div>
      </div>
      <div class="row d-flex py-4">
      <div class="col-12 col-md-6 mt-4 d-flex">
      <MDBCard text="center">
        <MDBCardBody v-once  class="flex-column d-flex">
          <MDBCardTitle v-once  tag="h2" class="text-uppercase h3">Studentenumzüge</MDBCardTitle>
          <MDBCardText v-once>
            <p>Wir von Umzug Bayern bieten dir einen professionellen Umzugsservice für Studenten in München – inklusive Verpackung, Transport, Reinigung und Parkorganisation. Mit uns genießt du faire Preise, sicheren Transport deiner Sachen und eine stressfreie Umzugsplanung.</p>
          </MDBCardText>
          <router-link alt="Studentenumzüge" title="Studentenumzüge" :to="{ name: 'studentenumzug' }" class="mt-auto btn   btn-primary btn-lg">Professionelle Tatortreinigung</router-link>
        </MDBCardBody>
      </MDBCard>
      </div>
      <div class="col-12 col-md-6 mt-4 d-flex">
        <MDBCard text="center">
          <MDBCardBody v-once  class="flex-column d-flex">
            <MDBCardTitle v-once  tag="h2" class="text-uppercase h3">Firmenumzüge und Büroumzüge</MDBCardTitle>
            <MDBCardText v-once>
              <p>Wir planen und führen Firmenumzüge in Bayern professionell durch, indem wir jeden Schritt sorgfältig organisieren – von der Auswahl des optimalen Umzugstages bis zur termingerechten Durchführung mit unserem erfahrenen Team und moderner Ausrüstung.</p>
            </MDBCardText>
            <router-link alt="Firmenumzug" title="Firmenumzug" :to="{ name: 'firmenumzuege' }" class="mt-auto btn   btn-primary btn-lg">Firmenumzüge</router-link>
          </MDBCardBody>
        </MDBCard>
      </div>
      </div>
      <div class="row d-flex py-4">
      <div class="col-12 col-md-6 mt-4 d-flex">
      <MDBCard text="center">
        <MDBCardBody v-once  class="flex-column d-flex">
          <MDBCardTitle v-once  tag="h2" class="text-uppercase h3">Möbelmontage</MDBCardTitle>
          <MDBCardText v-once>
            <p>Bei Umzug Bayern setzen wir auf Präzision, Effizienz und Zeitersparnis, um Ihre Möbelmontage nach einem Umzug oder Kauf fachgerecht und qualitativ hochwertig durchzuführen. Unsere erfahrenen Fachkräfte garantieren einen stabilen und ästhetischen Aufbau, sodass Sie sich auf andere Aspekte Ihres Umzugs konzentrieren können.</p>
          </MDBCardText>
          <router-link alt="Möbelmontage" title="Möbelmontage" :to="{ name: 'moebelmontage' }" class="mt-auto btn   btn-primary btn-lg">Möbelmontage</router-link>
        </MDBCardBody>
      </MDBCard>
      </div>
      <div class="col-12 col-md-6 mt-4 d-flex">
        <MDBCard text="center">
          <MDBCardBody v-once  class="flex-column d-flex">
            <MDBCardTitle v-once  tag="h2" class="text-uppercase h3">Umzugsratgeber</MDBCardTitle>
            <MDBCardText v-once>
              <p>Entdecken Sie in unserem Umzugsratgeber wertvolle Tipps und Schritt-für-Schritt-Anleitungen für eine stressfreie Planung und Durchführung Ihres Umzugs. Von Packhilfen bis hin zu Checklisten – wir unterstützen Sie mit praktischem Wissen für einen reibungslosen Umzug in Bayern und darüber hinaus.</p>
            </MDBCardText>
            <router-link alt="Umzugsratgeber" title="Umzugsratgeber" :to="{ name: 'blog' }" class="mt-auto btn   btn-primary btn-lg">Umzugsratgeber</router-link>
          </MDBCardBody>
        </MDBCard>
      </div>
      </div>
        <div class="col-xs-12" style="height:50px;"></div>
      </div>
    </div>
    </Article>
  </div>
</template>
<script>
// @ is an alias to /src
import Article from '@/components/Article.vue'
import { MDBCard, MDBCardBody, MDBCardTitle, MDBCardText } from 'mdb-vue-ui-kit'

export default {
  name: 'UmzugView',
  components: {
    MDBCard, MDBCardBody, MDBCardTitle, MDBCardText,
    Article
  },
  data: function() {
    return {

    }
  }
}
</script>
